/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Vincent RIBANO
 * @date        04/10/2019 16:49
 * @copyright   Copyright (c) 2002-2019 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

document.addEventListener('DOMContentLoaded', () => {
	// Permet d'aller chercher uniquement les règles de cross selling du panier
	if (
		$('[data-wpet-cross-selling-cart]').length > 0 &&
		$('[data-wpet-widget-booking-open-system]').length > 0
	) {
		const post_id = $('[data-wpet-cross-selling-cart]').attr('data-wpet-cross-selling-cart')
		console.log(post_id)
		$.ajax({
			url: `${IRISCollectionCustomer.ajaxThemeUrl}/cross-selling`,
			method: 'POST',
			data: {
				post_id: post_id,
			},
			success: (response) => {
				if (typeof response.content !== 'undefined' && response.content.length > 0) {
					$('[data-wpet-cross-selling-cart]:not(#section-cross-selling)').append(
						response.content,
					)
				}
			},
		})
	}
})
